module.exports = __webpack_public_path__ + "static/media/img-hero-section-it.4a4697b2.png";